module.exports = __webpack_public_path__ + "img/gartek-portfolio-generation-transmission.be8829cd.jpeg";